// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"dM-z","smallCardRow":"eM-z","largeCardRow":"fM-z","productSearchRow":"gM-z","curatedRow":"hM-z"};